import React, { useState } from 'react';
import { Grid, Card, CardMedia, CardContent, Typography, Container } from '@mui/material';
import Slider from 'react-slick';
import StarIcon from '@mui/icons-material/Star';
import test1 from '../images/avatarclints.png';
import test2 from '../images/avatarclints.png';
import test3 from '../images/avatarclints.png';
import test4 from '../images/avatarclints.png';
import backgroundImage from '../images/consultationbackgroundimage.jpg';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const theme = createTheme({
    palette: {
        primary: {
            main: '#6a52ff',
        },
    },
    typography: {
        h3: {
            fontWeight: 700,
            fontSize: '2rem',
        },
        h4: {
            fontWeight: 700,
            fontSize: '1.5rem',
        },
    },
});

const StyledSlider = styled(Slider)({
    '& .slick-prev, & .slick-next': {
        zIndex: 1,
        width: 30,
        height: 30,
        '&:before': {
            fontSize: 30,
            color: 'black',
        },
    },
    '& .slick-prev': {
        left: -35,
        top: 280,
    },
    '& .slick-next': {
        right: -35,
        top: 280,
    },
});

const HappyClients = () => {
    const [hoveredCard, setHoveredCard] = useState(null);

    const handleMouseEnter = (index) => {
        setHoveredCard(index);
    };

    const handleMouseLeave = () => {
        setHoveredCard(null);
    };

    const renderStars = (count) => {
        return (
            <Grid container justifyContent="center">
                {Array.from({ length: count }).map((_, index) => (
                    <StarIcon key={index} sx={{ color: '#684df4' }} />
                ))}
            </Grid>
        );
    };

    const renderAvatar = (imageSrc) => {
        return (
            <Grid
                sx={{
                    width: '120px',
                    height: '120px',
                    borderRadius: '50%',
                    backgroundColor: '#7f3ff2',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    backgroundImage: `url(${imageSrc})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            />
        );
    };

    const cards = [
        {
            name: 'Apoorva RS',

            stars: 5,
            image: test1,
            description:
                'SN Info Systems truly understood our needs and delivered exceptional results. They are our go-to partner for all things digital!',
        },
        {
            name: 'Sanketh T',

            stars: 5,
            image: test2,
            description:
                'Working with SN Info Systems was a game-changer for our business. Their dedication and expertise made a significant impact on our success.',
        },
        {
            name: 'Madhumitha',

            stars: 5,
            image: test3,
            description:
                'SN Info Systems not only met but exceeded our expectations. Their insights and solutions have helped us streamline operations and grow.',
        },
        {
            name: 'Nitish Kumar Ray',

            stars: 5,
            image: test4,
            description:
                'We couldnt be more pleased with SN Info Systems. They listened and they continue to support our growth with their expertise.',
        },
    ];

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                    dots: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
        ],
    };

    return (
        <ThemeProvider theme={theme}>
            <Grid container direction="column">
                <Grid
                    item
                    sx={{
                        position: 'relative',
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        minHeight: '70vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        color: 'white',
                        paddingTop: '1vh',
                    }}
                >
                    <Grid sx={{ marginTop: { md: '-300px', xs: -27 } }}>
                        <Typography sx={{ fontWeight: 700, marginBottom: 2, color: '#684df4', fontSize: 20, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>
                            CUSTOMER FEEDBACK
                        </Typography>
                        <Typography variant="h2" sx={{ fontWeight: 700, marginBottom: 2, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", fontSize: { md: 40, xs: 30 } }}>
                            What Happy Clients Say
                        </Typography>
                        <Typography variant="h4" sx={{ fontWeight: 600, color: theme.palette.primary.main, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>
                            About Us?
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    item
                    container
                    justifyContent="center"
                    sx={{
                        position: 'relative',
                        zIndex: 1,
                        marginTop: '-40vh',
                        padding: '20px',
                    }}
                >
                    <Container>
                        <StyledSlider {...settings}>
                            {cards.map((card, index) => (
                                <Grid item key={index} sx={{ padding: '0 10px' }}>
                                    <Card
                                        sx={{
                                            marginTop: 1.5,
                                            marginBottom: 1.5,
                                            height: '380px',
                                            textAlign: 'center',
                                            boxShadow: 3,
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            '&:hover': {
                                                transform: 'scale(1.05)',
                                                boxShadow: 6,
                                            },
                                        }}
                                        onMouseEnter={() => handleMouseEnter(index)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <CardMedia>
                                            <Grid container justifyContent="center" sx={{ marginTop: 3 }}>
                                                {renderAvatar(card.image)}
                                            </Grid>
                                        </CardMedia>
                                        <CardContent>
                                            {renderStars(card.stars)}
                                            <Typography variant="body2" color="textSecondary" sx={{ marginTop: '16px', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>
                                                {card.description}
                                            </Typography>
                                            <Typography variant="h6" component="div" sx={{ marginTop: '16px', fontWeight: 600, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>
                                                {card.name}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>
                                                {card.title}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </StyledSlider>
                    </Container>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
};

export default HappyClients;
